var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfitwell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#20323c",
    d: "M13.015 13.806H7.578a.712.712 0 01-.713-.713V7.66c0-.394.319-.713.713-.713h5.44v.002c.393 0 .712.319.712.711v5.434a.712.712 0 01-.712.712zm7.57-6.875l-5.854-5.854-.006.003a3.436 3.436 0 00-.994-.692v.008A3.397 3.397 0 0012.3.08H8.287a3.42 3.42 0 00-2.398.979h-.002L.955 5.988l.002.008A3.418 3.418 0 000 8.371V19.25a3.42 3.42 0 001.053 2.47l-.003.007 4.349 4.348.003-.002a.856.856 0 001.449-.467l.014-.001v-4.216h.001c0-.393.32-.712.713-.712H12.3c.95 0 1.81-.387 2.43-1.01l.008.002 4.796-4.796.001-.011c.05-.048.097-.101.144-.152l.907-.91z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#48a894",
    d: "M20.59 13.805h6.85L20.59 6.94z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#20323c",
    d: "M27.439 24.49l-.001-.02V13.8h-6.85v10.67a1.716 1.716 0 001.71 1.857h3.431c.907 0 1.648-.704 1.71-1.595z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitwell);
export default __webpack_public_path__ + "static/media/profitwell.5c8a6bcfb1e0f9f3f39bcf64f10f1779.svg";
export { ForwardRef as ReactComponent };